// Per-call HTTP method overrides layered over the contract's inferred methods
// (see `method` in client.ts).

// `listCatalog` is contracted as GET so its everyday reads stay cacheable and
// batch-adjacent, but the multiple-items filter sends up to 10,000 resolved
// product keys in `keys` — a payload that belongs in a request body, not a URL.
// Forced to POST whenever `keys` is present rather than relying on oRPC's
// URL-length fallback, so the transport is deterministic (and proxies/logs
// never see a multi-hundred-KB query string, of any size of key set).
const LIST_CATALOG_PATH = 'inventoryManagement/products/listCatalog';

/** True for a `listCatalog` call whose input carries a non-empty `keys` set. */
export function isKeyedListCatalogCall(
  path: readonly string[],
  input: unknown,
): boolean {
  if (path.join('/') !== LIST_CATALOG_PATH) return false;
  if (typeof input !== 'object' || input === null || !('keys' in input)) {
    return false;
  }
  const keys: unknown = input.keys;
  return Array.isArray(keys) && keys.length > 0;
}
